module.exports = __webpack_public_path__ + "img/3.af87555e.png";